import { postProblemAnswer } from '@yandex-int/k-common/client/api';
// @ts-ignore
import { showNetworkError } from 'platform-components/src/components/notification/actions';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { actions } from './actions';
import { ProblemWithAttempt } from './typings';

export function* problemsViewSagasWatcher() {
    yield all([takeLatest(actions.postAnswerRequest, postAnswerSaga)]);
}

function* postAnswerSaga(action: ReturnType<typeof actions.postAnswerRequest>) {
    try {
        const { problemId, answer } = action.payload;

        const problem: ProblemWithAttempt = yield call(postProblemAnswer, problemId, answer);

        yield put(actions.postAnswerSuccess({ problemId: problem.id, attempt: problem.attempt }));
    } catch (error) {
        const { problemId } = action.payload;

        console.error(error);

        yield put(showNetworkError(error));
        yield put(actions.postAnswerError({ problemId }));
    }
}
